/**
  Author: Suneel Singh - suneel.singh@enabledata.com
  Purpose: Procedure api models
  Date: April 2020
**/

import { action, thunk } from 'easy-peasy';
import * as proceduresService from '../../services/procedures';
var tempProcedureProgramAssociation = [];
var tempProcedureLoBAssociation = [];
var tempProcedureGroupAssociation = [];
var tempProcedurePolicyAssociation = [];
var tempProcedureClientAssociation = [];
var procedureInfoList = [];

const proceduresModel = {
  procedures: {},
  isProcedureInfoLoaded: false,

  setIsProcedureInfoLoaded: action((state, payload) => {
    state.isProcedureInfoLoaded = payload;
  }),

  setProcedures: action((state, payload) => {
    state.procedures = payload;
  }),
  getProcedures: thunk(async (actions, payload) => {
    const response = await proceduresService.getProcedures(payload);
    if (response) {
      actions.setProcedures(response.data.data);
      return response.data.data;
    }
  }),
  proceduresList: [],
  setProceduresList: action((state, payload) => {
    state.proceduresList = payload;
  }),
  proceduresListLoader: false,
  setProceduresListLoader: action((state, payload) => {
    state.proceduresListLoader = payload;
  }),
  getProceduresList: thunk(async (actions, payload, helpers) => {
    const state = helpers.getState();
    return await proceduresService
      .getProceduresList(payload)
      .then(function (response) {
        let procedureInfoList = response.data.data.items;
        actions.setProceduresListLoader(false);
        let newProceduresList = state.proceduresList;
        actions.setProceduresList([...newProceduresList, ...procedureInfoList]);
        if (response.data.data.pagination.next_page) {
          if (payload) {
            payload = {
              active: payload.active,
              next_page: response.data.data.pagination.next_page,
            };
          } else {
            payload = {
              next_page: response.data.data.pagination.next_page,
            };
          }
          actions.getProceduresList(payload);
        }
        return response;
      })
      .catch(function (error) {
        console.error(error);
        procedureInfoList = [];
        actions.setProceduresList([]);
        return error;
      }).finally(()=>{
        actions.setProceduresListLoader(false);
      });
  }),
  addProcedures: thunk(async (actions, payload) => {
    const response = await proceduresService.addProcedures(payload);
    procedureInfoList.push(response.data.data);
    return response;
  }),
  updateProcedures: thunk(async (actions, payload) => {
    const response = await proceduresService.updateProcedures(payload);
    for (let i = 0; i < procedureInfoList.length; i++) {
      if (procedureInfoList[i].PK === payload.PK) {
        procedureInfoList[i] = response.data.data;
      }
    }
    actions.setProceduresList(procedureInfoList);
    return response;
  }),
  association: {
    programs: {
      items: [],
      loader: false,
    },
    businesslines: {
      items: [],
      loader: false,
    },
    groups: {
      items: [],
      loader: false,
    },
    policies: {
      items: [],
      loader: false,
    },
    clients: {
      items: [],
      loader: false,
    },
  },

  //Association List Procedure -> clients
  setProcedureClientAssociationLoader: action((state, payload) => {
    state.association.clients.loader = payload;
  }),
  setProcedureClientAssociation: action((state, payload) => {
    state.association.clients.items = payload;
  }),
  getProcedureClientAssociation: thunk(async (actions, payload) => {
    actions.setProcedureClientAssociationLoader(true);
    // stop recursive call once page route will changed
    if (window.location.pathname.includes('/procedures') == false) {
      return false;
    }
    return await proceduresService
      .getProcedureClientAssociation(payload)
      .then(function (response) {
        if (payload.repeatAPI === true) {
          tempProcedureClientAssociation =
            tempProcedureClientAssociation.concat(
              response.data.data.associations,
            );
        } else {
          tempProcedureClientAssociation = response.data.data.associations;
        }
        actions.setProcedureClientAssociation(tempProcedureClientAssociation);
        if (response.data.data.lastEvalKeyNew) {
          payload = {
            id: payload.id,
            type: payload.type,
            with: payload.with,
            lastEvalKeyNew: response.data.data.lastEvalKeyNew,
            repeatAPI: true,
          };
          actions.getProcedureClientAssociation(payload);
        } else {
          actions.setProcedureClientAssociationLoader(false);
        }
        return response;
      })
      .catch(function (error) {
        actions.setProcedureClientAssociation([]);
        return error;
      });
  }),
  // Asso List Procedure LoB
  setProcedureLoBAssociationLoader: action((state, payload) => {
    state.association.businesslines.loader = payload;
  }),
  setProcedureLoBAssociation: action((state, payload) => {
    state.association.businesslines.items = payload;
  }),
  getProcedureLoBAssociation: thunk(async (actions, payload) => {
    actions.setProcedureLoBAssociationLoader(true);
    // stop recursive call once page route will changed
    if (window.location.pathname.includes('/procedures') == false) {
      return false;
    }
    return await proceduresService
      .getProcedureLoBAssociation(payload)
      .then(function (response) {
        if (payload.repeatAPI === true) {
          tempProcedureLoBAssociation = tempProcedureLoBAssociation.concat(
            response.data.data.associations,
          );
        } else {
          tempProcedureLoBAssociation = response.data.data.associations;
        }
        actions.setProcedureLoBAssociation(tempProcedureLoBAssociation);
        if (response.data.data.lastEvalKeyNew) {
          payload = {
            id: payload.id,
            type: payload.type,
            with: payload.with,
            lastEvalKeyNew: response.data.data.lastEvalKeyNew,
            repeatAPI: true,
          };
          actions.getProcedureLoBAssociation(payload);
        } else {
          actions.setProcedureLoBAssociationLoader(false);
        }
        return response;
      })
      .catch(function (error) {
        actions.setProcedureLoBAssociation([]);
        return error;
      });
  }),
  // Asso List Procedure Group
  setProcedureGroupAssociationLoader: action((state, payload) => {
    state.association.groups.loader = payload;
  }),
  setProcedureGroupAssociation: action((state, payload) => {
    state.association.groups.items = payload;
  }),
  getProcedureGroupAssociation: thunk(async (actions, payload) => {
    actions.setProcedureGroupAssociationLoader(true);
    // stop recursive call once page route will changed
    if (window.location.pathname.includes('/procedures') == false) {
      return false;
    }
    return await proceduresService
      .getProcedureGroupAssociation(payload)
      .then(function (response) {
        if (payload.repeatAPI === true) {
          tempProcedureGroupAssociation = tempProcedureGroupAssociation.concat(
            response.data.data.associations,
          );
        } else {
          tempProcedureGroupAssociation = response.data.data.associations;
        }
        actions.setProcedureGroupAssociation(tempProcedureGroupAssociation);
        if (response.data.data.lastEvalKeyNew) {
          payload = {
            id: payload.id,
            type: payload.type,
            with: payload.with,
            lastEvalKeyNew: response.data.data.lastEvalKeyNew,
            repeatAPI: true,
          };
          actions.getProcedureGroupAssociation(payload);
        } else {
          actions.setProcedureGroupAssociationLoader(false);
        }
        return response;
      })
      .catch(function (error) {
        actions.setProcedureGroupAssociation([]);
        return error;
      });
  }),
  // Asso List Procedure Program
  setProcedureProgramAssociationLoader: action((state, payload) => {
    state.association.programs.loader = payload;
  }),
  setProcedureProgramAssociation: action((state, payload) => {
    state.association.programs.items = payload;
  }),
  getProcedureProgramAssociation: thunk(async (actions, payload) => {
    actions.setProcedureProgramAssociationLoader(true);
    // stop recursive call once page route will changed
    if (window.location.pathname.includes('/procedures') == false) {
      return false;
    }
    return await proceduresService
      .getProcedureProgramAssociation(payload)
      .then(function (response) {
        if (payload.repeatAPI === true) {
          tempProcedureProgramAssociation =
            tempProcedureProgramAssociation.concat(
              response.data.data.associations,
            );
        } else {
          tempProcedureProgramAssociation = response.data.data.associations;
        }
        actions.setProcedureProgramAssociation(tempProcedureProgramAssociation);
        if (response.data.data.lastEvalKeyNew) {
          payload = {
            id: payload.id,
            type: payload.type,
            with: payload.with,
            lastEvalKeyNew: response.data.data.lastEvalKeyNew,
            repeatAPI: true,
          };
          actions.getProcedureProgramAssociation(payload);
        } else {
          actions.setProcedureProgramAssociationLoader(false);
        }
        return response;
      })
      .catch(function (error) {
        actions.setProcedureProgramAssociation([]);
        return error;
      });
  }),
  // Asso List Procedure Policy
  setProcedurePolicyAssociationLoader: action((state, payload) => {
    state.association.policies.loader = payload;
  }),
  setProcedurePolicyAssociation: action((state, payload) => {
    state.association.policies.items = payload;
  }),
  getProcedurePolicyAssociation: thunk(async (actions, payload) => {
    actions.setProcedurePolicyAssociationLoader(true);
    // stop recursive call once page route will changed
    if (window.location.pathname.includes('/procedures') == false) {
      return false;
    }
    return await proceduresService
      .getProcedurePolicyAssociation(payload)
      .then(function (response) {
        if (payload.repeatAPI === true) {
          tempProcedurePolicyAssociation =
            tempProcedurePolicyAssociation.concat(
              response.data.data.associations,
            );
        } else {
          tempProcedurePolicyAssociation = response.data.data.associations;
        }
        actions.setProcedurePolicyAssociation(tempProcedurePolicyAssociation);
        if (response.data.data.lastEvalKeyNew) {
          payload = {
            id: payload.id,
            type: payload.type,
            with: payload.with,
            lastEvalKeyNew: response.data.data.lastEvalKeyNew,
            repeatAPI: true,
          };
          actions.getProcedurePolicyAssociation(payload);
        } else {
          actions.setProcedurePolicyAssociationLoader(false);
        }
        return response;
      })
      .catch(function (error) {
        actions.setProcedurePolicyAssociation([]);
        return error;
      });
  }),
  updateProcedureStatus: thunk(async (actions, payload) => {
    return await proceduresService.updateProcedureStatus(payload);
  }),
};

export default proceduresModel;
